import { BackButton } from '@/components/BackButton/BackButton'
import { Stack, useRouter } from 'expo-router'
import { Text } from 'react-native'

export default function () {
  const router = useRouter()
  return (
    <Stack
      screenOptions={{
        gestureEnabled: false,
        headerStyle: {
          backgroundColor: 'rgb(5, 16,45)'
        },
        headerLeft: () => <BackButton navigate={() => router.back()} />,
        headerTitle: () => <Text />
      }}
    />
  )
}
